import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
	body: {
		height: '60vh',
	},
	children: {
		height: 'inherit',
	},
	card: {
		display: 'block',
		height: '60%',
		marginTop: '40px',
		background: '#757ce8',
	},
	typography: {
		textAlign: 'center',
	},
	new: {
		marginBottom: '20px',
	},
});

export default useStyles;
